import React from 'react';
import styled, { css } from 'styled-components';

const Checkmark = styled(({ className }) => (
  <span>
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
    >
      <circle
        className="checkmark__circle"
        cx="26"
        cy="26"
        r="25"
        fill="none"
      />
      <path
        className="checkmark__check"
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
      />
    </svg>
  </span>
)).attrs(() => ({
  color: '#50B83C',
  curve: 'cubic-bezier(0.650, 0.000, 0.450, 1.000)',
}))`
  border-radius: 50%;
  display: block;
  stroke-width: 5;
  stroke: #fff;
  stroke-miterlimit: 10;
  box-shadow: inset 0px 0px 0px ${(props) => props.color};
  ${(props) =>
    props.animate &&
    css`
      animation: animated-checkmark-fill 0.4s ease-in-out 0.4s forwards,
        animated-checkmark-scale 0.3s ease-in-out 0.9s both;
    `}

  ${(props) =>
    !props.animate &&
    css`
      box-shadow: inset 0px 0px 0px 30px ${(props) => props.color};
    `}

  .checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: ${(props) => props.color};
    fill: none;
    ${(props) =>
      props.animate &&
      css`
        animation: animated-checkmark-stroke 0.6s ${(props) => props.curve}
          forwards;
      `}
    ${(props) =>
      !props.animate &&
      css`
        box-shadow: inset 0px 0px 0px 30px ${(props) => props.color};
      `}
  }

  .checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;

    ${(props) =>
      props.animate &&
      css`
        animation: animated-checkmark-stroke 0.3s ${(props) => props.curve} 0.8s
          forwards;
      `}
    ${(props) =>
      !props.animate &&
      css`
        stroke-dashoffset: 0;
      `}
  }

  @keyframes animated-checkmark-stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }

  @keyframes animated-checkmark-scale {
    0%,
    100% {
      transform: none;
    }
    50% {
      transform: scale3d(1.1, 1.1, 1);
    }
  }

  @keyframes animated-checkmark-fill {
    100% {
      box-shadow: inset 0px 0px 0px 30px ${(props) => props.color};
    }
  }
`;

export default styled(Checkmark)`
  position: absolute;
  top: -7px;
  right: -8px;
  width: 18px;
  height: 18px;
`;

export const FullSizeCheckmark = styled(Checkmark)`
  width: 40px;
  height: 40px;
`;
